import { render } from "./FilterTagButton.vue?vue&type=template&id=14451d0c&scoped=true"
import script from "./FilterTagButton.vue?vue&type=script&lang=js"
export * from "./FilterTagButton.vue?vue&type=script&lang=js"

import "./FilterTagButton.vue?vue&type=style&index=0&id=14451d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14451d0c"]])

export default __exports__